/* eslint-disable @typescript-eslint/no-explicit-any */
import React, { createContext, useState, useContext } from 'react';
import { IonActionSheet } from '@ionic/react';
const store = createContext({ state: {}, setState: () => null });
const { Provider } = store;
const ActionSheetProvider = (props) => {
    const [state, setState] = useState({});
    return React.createElement(Provider, { value: { state, setState } },
        React.createElement(IonActionSheet, { isOpen: state.show || false, onDidDismiss: () => setState(Object.assign(Object.assign({}, state), { show: false })), cssClass: state.cssClass, buttons: state.buttons }),
        props.children);
};
function useActionSheet() {
    const ActionSheetContext = useContext(store);
    const showActionSheet = (buttons, props) => {
        ActionSheetContext.setState(Object.assign(Object.assign({}, props), { show: true, buttons: buttons }));
    };
    const hideActionSheet = () => {
        ActionSheetContext.setState(Object.assign(Object.assign({}, ActionSheetContext.state), { show: false }));
    };
    return {
        showActionSheet: showActionSheet,
        hideActionSheet: hideActionSheet
    };
}
export { store as ActionSheetStore, ActionSheetProvider, useActionSheet };
//# sourceMappingURL=index.js.map